var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 8,
  height: 16,
  viewBox: "0 0 8 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Polygon_54",
  "data-name": "Polygon 54",
  d: "M8,0l8,8H0Z",
  transform: "translate(8) rotate(90)",
  fill: "#898989"
})));
export default __webpack_public_path__ + "static/media/play-icon.44d8a1e5.svg";
export { SvgComponent as ReactComponent };